"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _moment = _interopRequireDefault(require("moment"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactSizeme = require("react-sizeme");

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _vars = require("@devsta/ui-kit/dist/common/styles/vars");

var _uiKit = require("@devsta/ui-kit");

var _reactResponsive = _interopRequireDefault(require("react-responsive"));

var _getUserFullName = _interopRequireDefault(require("@devsta/get-user-full-name"));

var _commonReact = require("@devsta/common-react");

var _AssetDetails = _interopRequireDefault(require("./AssetDetails"));

var _utils = require("../utils");

var _mediaSizes = _interopRequireDefault(require("../../../../../common/constants/mediaSizes"));

require("../styles/_asset-list-item.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var getDate = (0, _memoizeOne.default)(function (date) {
  var momentDate = (0, _moment.default)(date, ['x', 'YYYY-MM-DDTHH:mm:ss.sssZ']);
  var formattedDate = momentDate.format('DD MMM YYYY');
  var time = momentDate.format('h:mma z');
  return "".concat(formattedDate, " at ").concat(time);
});

function AssetListItem(_ref) {
  var item = _ref.item,
      handleClick = _ref.handleClick,
      options = _ref.options;
  return _react.default.createElement(_reactSizeme.SizeMe, null, function (_ref2) {
    var size = _ref2.size;
    return _react.default.createElement(_uiKit.List.ListItem, {
      key: item.assetId,
      onClick: handleClick,
      actionPopupOptions: options,
      hideImage: true
    }, _react.default.createElement("div", {
      className: (0, _classnames.default)('library-list-item', {
        'library-list-item--small': size.width < _mediaSizes.default.small
      })
    }, _react.default.createElement("div", {
      className: "library-list-item__column"
    }, _react.default.createElement(_commonReact.AssetPreview, (0, _utils.getAssetPreviewProps)({
      asset: item,
      width: 90,
      height: 90
    })), _react.default.createElement(_AssetDetails.default, {
      title: item.title,
      subTitle: item.description,
      fileName: item.filename
    })), _react.default.createElement("div", {
      className: "library-list-item__column"
    }, _react.default.createElement(_reactResponsive.default, {
      minWidth: _vars.NUMERIC_MEDIA_SIZES.small + 1
    }, _react.default.createElement(_uiKit.List.ListItem.UserDetails, {
      userName: (0, _getUserFullName.default)(item.updatedByUser),
      profileImage: item.updatedByUser && item.updatedByUser.imageUrl
    }, _react.default.createElement("p", {
      className: "library-list-item__job-title"
    }, item.updatedByUser && item.updatedByUser.jobTitle))), _react.default.createElement("div", {
      className: "library-list-item__date"
    }, _react.default.createElement("div", {
      className: "library-list-item__date__timestamp"
    }, _react.default.createElement("p", {
      className: "library-list-item__date__timestamp__text"
    }, getDate(item.updatedAt))), _react.default.createElement("p", {
      className: "library-list-item__date__text"
    }, "Last Updated")))));
  });
}

var _default = (0, _react.memo)(AssetListItem);

exports.default = _default;